import { Stack, Container, useMediaQuery, useTheme } from "@mui/material";
import { Text } from "../components/Text";
import { Parentheses } from "../components/Parentheses";
import { TextKv } from "../components/TextKv";

export const Privacy = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const list = [
    {
      title: "1. 個人情報の収集について",
      text: "当社は、お客様が本サイトを利用する際に、以下の情報を収集することがあります。\n- 氏名、住所、電話番号、メールアドレス\n- アクセスログ、IPアドレス、Cookie等の情報\n- お問い合わせ内容、アンケートの回答",
    },
    {
      title: "2. 個人情報の利用目的",
      text: "当社は、お客様の個人情報を以下の目的で利用いたします。\n- お問い合わせ対応\n- サービスの提供および運営\n- マーケティング調査および分析\n- 法令に基づく対応",
    },
    {
      title: "3. 個人情報の管理",
      text: "当社は、お客様の個人情報を適切に管理し、不正アクセス、紛失、改ざん、漏洩を防止するための措置を講じます。",
    },
    {
      title: "4. 個人情報の第三者提供について",
      text: "当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。\n- お客様の同意がある場合\n- 法令に基づく場合\n- 業務委託先に対し、業務遂行に必要な範囲で開示する場合",
    },
    {
      title: "5. 個人情報の開示・訂正・削除について",
      text: "お客様は、当社が保有する自己の個人情報について、開示・訂正・削除を請求することができます。その際は、下記お問い合わせ窓口までご連絡ください。",
    },
    {
      title: "6. Cookie等の利用について",
      text: "本サイトでは、より良いサービス提供のためにCookie等を使用することがあります。お客様は、ブラウザの設定によりCookieの受け取りを拒否することができます。",
    },
    {
      title: "7. プライバシーポリシーの変更",
      text: "本ポリシーの内容は、必要に応じて改訂することがあります。変更後のプライバシーポリシーは、本サイト上に掲載した時点で効力を生じるものとします。",
    },
    {
      title: "8. お問い合わせ窓口",
      text: "本ポリシーに関するお問い合わせは、以下の窓口までご連絡ください。\n\n株式会社 MycoGenome\n[住所] 102-0071　東京都千代田区富士見1-3-11　富士見デュープレックスB’s 4F\n[メールアドレス] support.mg@mycogenome.co.jp",
    },
  ];

  const listEn = [
    {
      title: "1. Collection of Personal Information",
      text: "We may collect the following information when you use the Site:\n- Name, address, telephone number, e-mail address\n- Information such as access logs, IP addresses, cookies, etc.\n- Content of inquiries and responses to questionnaires",
    },
    {
      title: "2. Purpose of Use of Personal Information",
      text: "We will use your personal information for the following purposes:\n- To respond to inquiries\n- Provision and operation of services\n- Marketing research and analysis\n- To comply with laws and regulations",
    },
    {
      title: "3. Management of Personal Information",
      text: "We will appropriately manage your personal information and take measures to prevent unauthorized access, loss, falsification, and leakage.",
    },
    {
      title: "4. Provision of Personal Information to Third Parties",
      text: "We will not provide customers' personal information to third parties, except in the following cases:\n- When we have the customer's consent\n- When required by law\n- When disclosing personal information to subcontractors to the extent necessary for the performance of their duties",
    },
    {
      title: "5. Disclosure, Correction, and Deletion of Personal Information",
      text: "Customers may request the disclosure, correction, or deletion of their own personal information held by the Company. Please contact us at the following contact point for such requests.",
    },
    {
      title: "6. Use of Cookies",
      text: "Cookies may be used on this site to provide better service. You may set your browser to refuse cookies.",
    },
    {
      title: "7. Changes to This Privacy Policy",
      text: "The contents of this policy may be revised as necessary. The revised Privacy Policy will be effective when posted on this Site.",
    },
    {
      title: "8. Contact for Inquiries",
      text: "If you have any questions regarding this policy, please contact us at the following address:\n\nMycoGenome Inc. \n[Address] 4F Fujimi Duplex B’s, 1-3-11 Fujimi, Chiyoda-ku, Tokyo 102-0071, Japan \n[E-mail address] support.mg@mycogenome.co.jp",
    },
  ];

  return (
    <Stack>
      <TextKv text="プライバシーポリシー" en="Privacy policy" />
      <Container>
        <Parentheses>
          <Stack>
            <Stack>
              <Text>
                本プライバシーポリシーは、株式会社
                MycoGenome（以下、「当社」といいます。）が提供するウェブサイト（以下、「本サイト」といいます。）における、ユーザー（以下、「お客様」といいます。）の個人情報の取り扱いについて定めるものです。
              </Text>
              {list.map((item, index) => {
                return (
                  <Stack key={index} marginTop={2}>
                    <Text variant="h6" fontSize={isMobile ? 16 : 20}>
                      {item.title}
                    </Text>
                    <Text whiteSpace="pre-wrap">{item.text}</Text>
                  </Stack>
                );
              })}
            </Stack>
            <br />
            <br />
            <Stack>
              <Text>
                This Privacy Policy applies to the website ("Site") provided by
                MycoGenome, Inc. (hereinafter referred to as "the Company").
                This policy governs the handling of personal information of
                users (hereinafter referred to as "Customers") on the Site.
              </Text>
              {listEn.map((item, index) => {
                return (
                  <Stack key={index} marginTop={2}>
                    <Text variant="h6" fontSize={isMobile ? 16 : 20}>
                      {item.title}
                    </Text>
                    <Text whiteSpace="pre-wrap">{item.text}</Text>
                  </Stack>
                );
              })}
            </Stack>
          </Stack>
        </Parentheses>
      </Container>
    </Stack>
  );
};
